export default __webpack_public_path__ + "static/media/gallery_08.a6861d95.jpg";